"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectsConverter = void 0;
const LinkEntity_1 = require("../common/model/LinkEntity");
class SubjectsConverter {
    static convert(response) {
        const links = {};
        if (response._links) {
            if (response._links.update && response._links.update.href) {
                links.update = new LinkEntity_1.Link({ href: response._links.update.href });
            }
        }
        return {
            id: response.id,
            name: response.name,
            links,
        };
    }
}
exports.SubjectsConverter = SubjectsConverter;
//# sourceMappingURL=SubjectsConverter.js.map